import React, { useEffect } from 'react'
import { ActivityIndicator } from 'react-native'

import { useNavigation, useRoute } from '@react-navigation/native'
import useMyCustomersStore from '@zet/customer/src/store/myCustomers'
import { Stack } from '@zet/design-system/layout'
import { useExperiments } from '@zet/experiments'
import {
  useBrandDetailsById,
  useFilteredRecommendationForPartner,
} from '@zet/feature-brands/api/brands/hooks'

const BrandSpecificRecommendationLoader = () => {
  const { params } = useRoute()
  const navigation = useNavigation()
  const { data: experiment } = useExperiments()
  const { setPartnerId } = useMyCustomersStore((state) => state)
  const partnerId = params?.brandId
  const { data: content } = useBrandDetailsById(partnerId)
  const {
    data: isEligible,
    isLoading,
    isSuccess,
  } = useFilteredRecommendationForPartner({
    customerId: params?.customerId,
    partnerId: partnerId,
  })

  useEffect(() => {
    return () => {
      setPartnerId(null)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setPartnerId])

  useEffect(() => {
    if (!isLoading && isSuccess) {
      if (isEligible?.value) {
        if (experiment?.[`UI_ASSISTED_JOURNEY_${partnerId}`]) {
          navigation.replace('BrandFillApplicationLoadingPage', {
            brandName: content?.name,
            brandId: partnerId,
            customerId: params?.customerId,
            customerName: params?.customerName,
            leadSource: 'Assisted_lead_listing',
            isEligibleBrand: isEligible?.value,
          })
        } else {
          navigation.replace('ShareCardLink', {
            customerId: params?.customerId || '',
            customerName: params?.customerName || '',
            customerPhoneNumber: params?.customerPhoneNumber || '',
            showScratchCard: true,
            brandId: partnerId,
          })
        }
      } else {
        navigation.replace('BrandPage', {
          customerId: params?.customerId || '',
          customerName: params?.customerName || '',
          customerPhoneNumber: params?.customerPhoneNumber || '',
          showScratchCard: true,
          routeName: 'forCustomerFlow',
          partnerId,
        })
      }
    }
  }, [isEligible, isLoading, isSuccess, navigation, params, partnerId])

  return (
    <Stack className="flex-1 items-center justify-center">
      <ActivityIndicator size={'large'} />
    </Stack>
  )
}

export default BrandSpecificRecommendationLoader
